/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum DeleteClearanceCaseDocumentResult {
  Success = 0,
  Error = 1,
  DocumentNotFound = 2,
  CaseNotFound = 3,
}
